import { render, staticRenderFns } from "./RolesAtTheProjectLevel.vue?vue&type=template&id=541ee282&scoped=true"
import script from "./RolesAtTheProjectLevel.vue?vue&type=script&lang=js"
export * from "./RolesAtTheProjectLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541ee282",
  null
  
)

export default component.exports